export const ENTITY_TYPE = {
  HIGHLIGHT: 'HIGHLIGHT',
  FIXED_WORD: 'FIXED_WORD',
};

export const ENTITY_MUTABILITY = {
  IMMUTABLE: 'IMMUTABLE',
};

export const NSW_STATUS = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
};

export const NSW_TYPE = {
  ABBREVIATION: 'abbreviation',
  LOANWORD: 'loanword',
};

export const DICTIONARY_ALLOWED_TYPES = [
  NSW_TYPE.ABBREVIATION,
  NSW_TYPE.LOANWORD,
];
